import axios from 'axios';

const baseURL = "https://odds.p.rapidapi.com/v4/sports"

const headers = {
  'X-RapidAPI-Host': 'odds.p.rapidapi.com', 
  // 'X-RapidAPI-Key': '5049a344aemshc35b7b8978f46a4p14876fjsnadf9b3cd2973'
  // 'X-RapidAPI-Key': '544d630fe0msh950f8353f296917p1f63bfjsn1197e92ea007'
  'X-RapidAPI-Key':'f357cac52amsh64cd715c3dd294bp19b239jsn1f052181ea9d'
};


export async function getAllSportsData() {
  try {
    const params = { all: 'true' };
    const { data } = await axios.get(baseURL, { headers, params });
    return data;
  } catch (err) {
    console.error(err);
    return err;
  }
}


export async function getScoresBySport(sportKey) {
  try {
    const params = {daysFrom: '2'};
    const { data } = await axios.get(`${baseURL}/${sportKey}/scores`, { headers, params });
    return data;    
  } catch (err) {
    console.error (err);
    return err;
  }
}